function applyProjectFilter(filterValue) {
  const allRows = document.querySelectorAll('.bldg-work-grid__row');

  allRows.forEach(row => {
    const items = row.querySelectorAll('.bldg-work-grid__item');
    let matchFound = false;

    items.forEach(item => {
      const industries = item.dataset.industries;
      const isMatch = industries && industries.toLowerCase().includes(filterValue.toLowerCase().trim());

      if (filterValue === 'all' || isMatch) {
        item.style.display = 'block';
        requestAnimationFrame(() => item.classList.add('visible'));
        matchFound = true;
      } else {
        item.classList.remove('visible');
        item.style.display = 'none';
      }
    });

    row.style.display = matchFound ? 'flex' : 'none';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const filter = document.querySelector('.work-filter');
  if (!filter) return;

  const toggle = filter.querySelector('.work-filter__toggle');
  const dropdown = filter.querySelector('.work-filter__dropdown');
  const plus = filter.querySelector('.work-filter__plus');
  const selected = filter.querySelector('.work-filter__selected h1');
  const optionButtons = filter.querySelectorAll('.work-filter__option');

  toggle.addEventListener('click', function () {
    dropdown.classList.toggle('open');
    plus.classList.toggle('active');
  });

  optionButtons.forEach(option => {
    option.addEventListener('click', function () {
      const filterValue = this.dataset.filter;
      const labelText = this.querySelector('h2') ? this.querySelector('h2').textContent : this.textContent;

      // Update header text
      selected.textContent = labelText.trim();

      // Close menu
      dropdown.classList.remove('open');
      plus.classList.remove('active');

      // Filter grid items
      applyProjectFilter(filterValue);
    });
  });

  // Apply default filter on load
  applyProjectFilter('all');
});